import { InjectionToken } from '@angular/core';

export interface RouteAccessAuthorizer {
  canAccessRoute(url: string): boolean;
  getAllowedRoutes(): readonly string[];
  logout(): Promise<void>;
}

export const ROUTE_ACCESS_AUTHORIZER = new InjectionToken<RouteAccessAuthorizer>(
  'ROUTE_ACCESS_AUTHORIZER',
);
